import React, { useEffect, useRef, useState } from "react"
import styles from "@/components/Remedy/components/TextInfoBlock1/TextInfoBlock1.module.scss"
import { Box, Button, Typography } from "@kohler-dsm-library/kohler-core"
import { handleRegisterPreorderAnalytics } from "@/components/Remedy/components/analytics"

export const TextInfoBlock1 = ({
  title,
  ctaText,
  ctaLinkText,
  ctaLinkHref,
}) => {
  const elementRef = useRef(null)
  const [showElement, setShowElement] = useState(false)

  const rectListener = () => {
    if (!elementRef.current) return

    const rect = elementRef.current.getBoundingClientRect()
    if (rect.y < 10) {
      setShowElement(true)
    }
  }

  const bindListeners = () => {
    window.addEventListener("scroll", rectListener)
    window.addEventListener("wheel", rectListener)
    window.addEventListener("touchmove", rectListener)
  }

  const unbindListeners = () => {
    window.removeEventListener("scroll", rectListener)
    window.removeEventListener("wheel", rectListener)
    window.removeEventListener("touchmove", rectListener)
  }

  useEffect(() => {
    bindListeners()

    return () => {
      unbindListeners()
    }
  }, [])

  useEffect(() => {
    if (showElement) {
      unbindListeners()
    }
  }, [showElement])

  return (
    <Box
      ref={elementRef}
      component="div"
      mod="charcoal"
      className={styles["text-info-block-1"]}
    >
      <div
        className={styles["__cta"]}
        style={{ transform: `translateY(${showElement ? 0 : -100}%)` }}
      >
        <Typography component="span" size="label-regular-l">
          {ctaText}
        </Typography>
        <Button
          component="a"
          size="small"
          target="_blank"
          rel="noreferrer"
          href={ctaLinkHref}
          onClick={() =>
            handleRegisterPreorderAnalytics(ctaText, ctaLinkText, ctaLinkHref)
          }
        >
          {ctaLinkText}
        </Button>
      </div>
    </Box>
  )
}
